var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "materialDelivery" }, [
      _c("div", { staticClass: "top" }, [
        _c("img", {
          staticClass: "materialDelivery-img",
          attrs: {
            src: require("../../../assets/images/degreeApplication/materialDelivery.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "cont" }, [
        _c("h1", { staticClass: "cont-title" }, [_vm._v("申报材料快递")]),
        _c("div", { staticClass: "tips" }, [
          _vm._v(
            "注意：每次申报的收件截止时间！！（截止日期见每学期学位申报通知文件）"
          ),
        ]),
        _c("div", { staticClass: "text" }, [
          _vm._v(" 纸质材料请按顺序装订成册（“学士学位申请登记表”居前）后 "),
          _c("span", { staticClass: "color-red" }, [
            _vm._v("通过顺丰速运，按通知要求寄送"),
          ]),
          _vm._v(" 。 "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }